import { ComponentProps } from 'react';
import { Textarea } from '@utilities-one/gpm-ui';

import { FormBase } from '@/library/form/components/FormBase';
import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps } from '@/library/form/types/form.type';

type FormTextareaProps = FormControlProps & {
  textareaProps?: ComponentProps<typeof Textarea>;
};

export function FormTextarea({ textareaProps, ...props }: FormTextareaProps) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <FormBase {...props}>
      <Textarea
        {...textareaProps}
        id={field.name}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        aria-invalid={isInvalid}
      />
    </FormBase>
  );
}
